import { useState, useEffect } from 'react';
import { useError } from '../../contexts/ErrorContext';
import { DealerService } from '../../services';
import TestTransactionTable from './TestTransactionTable';

const TestTransactions = (props) => {
    const { showError } = useError();
    const [testTransactions, setTestTransactions] = useState(null);

    useEffect(() => {
        if (testTransactions === null) {
            DealerService.getAllTestTransactions().then(setTestTransactions).catch(showError);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [testTransactions]);

    return (
        <div id="test-transaction-container">
          <h1>Test Transactions</h1>
          <TestTransactionTable testTransactions={testTransactions} />
        </div>
    );
}

export default TestTransactions;